module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-btn-3c27e0bb.svg";